import { render, staticRenderFns } from "./Shoulder.vue?vue&type=template&id=48daa6a1&scoped=true"
import script from "./Shoulder.vue?vue&type=script&lang=js"
export * from "./Shoulder.vue?vue&type=script&lang=js"
import style0 from "./Shoulder.vue?vue&type=style&index=0&id=48daa6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48daa6a1",
  null
  
)

export default component.exports